import React, { useEffect, useState } from "react";
import PrivateApi from "../../services/PrivateApiService";
import { Col, Container, Row } from "react-bootstrap";
import BuildingComponent from "../../components/hw/BuildingComponent";
import { useParams } from "react-router-dom";
import SplashPage from "../SplashPage";
import InvoiceTable from "../../components/invoice/InvoiceTable";
import { useQuery } from "react-query";
import EnergoTooltip from "../../components/shared/EnergoTooltip";

/**
 * InvoicePage
 * 
 * displays invoices for selected building and has posibility to download them in zip files
 * 
 * @returns none
 */
const InvoicePage = () => {

    const API = new PrivateApi(); // API calls
    const { building_id } = useParams(); // building parameter passed from BuildingPage
    const [selectedAnlageId, setSelectedAnlageId] = useState([]); // array state for selected (clicked) Anlage
    const [selectedInvoices, setSelectedInvoices] = useState([]); // array state for filtered Invoices

    const [building, setBuilding] = useState(); // object state for building
    const [anlagen, setAnlagen] = useState([]); // array state for Anlagen
    const [invoices, setInvoices] = useState([]); // initial array of Invoices


    const { data, error, isLoading } = useQuery(["GET_BUILDING_INVOICES", building_id], () => API.hw_InvoicesBuilding(building_id), {
        enabled: building_id !== undefined,
        staleTime: Infinity,
        onSuccess: (data) => {
            var res = data.data;
            setBuilding(res.building);
            setAnlagen(res.anlagen);
            setInvoices(res.poolrechnungen.concat(res.abrechnungen).concat(res.vorschreibungen));
            setSelectedInvoices(res.poolrechnungen.concat(res.abrechnungen).concat(res.vorschreibungen));
        }
    })


    // Effect triggers when Anlage is selected (clicked). filter invoices
    useEffect(() => {
        if (selectedAnlageId.length > 0) {
            var filtered = invoices.filter(i => Number(i.x_anlage_id.split(",")[0].replace('[', '')) === selectedAnlageId[0]);
            setSelectedInvoices(filtered);
        } else {
            setSelectedInvoices(invoices);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedAnlageId])


    if (isLoading) return <SplashPage />
    if (error) return <SplashPage error={error} />

    // GUI
    return (
        <Container>
            <Row className="text-start mb-5">
                <Col>
                    <div style={{display: "flex"}}>
                        <h3 style={{marginRight: 10}}>Dokumente</h3>
                        <EnergoTooltip tKey="4001" position="right" />
                    </div>
                    <p className="text-muted">{building ? building.name : 'Ihre Abrechnungen bei ENERGO'}</p>
                </Col>
            </Row>
            <Row>
                <BuildingComponent selected={selectedAnlageId} setSelected={setSelectedAnlageId} building={building} anlagen={anlagen} />
            </Row>

            <Row>
                <Col xs="12">
                    <InvoiceTable selectedAnlage={selectedAnlageId} setSelectedAnlage={setSelectedAnlageId} invoices={selectedInvoices} />
                </Col>
            </Row>
        </Container>
    )
}

export default InvoicePage;